module.exports = __webpack_public_path__ + "img/mcpro.3f760f3b.svg";